import appConfig from "../app";

const apiConfig = {
    API_URL_AUTH : appConfig.API_URL + "/common/credencialesAuth",
    API_URL_CLIENTES : appConfig.API_URL + "/common/clientes/usuarios/{usuarioID}",
    API_URL_CONSUMOS : appConfig.API_URL + "/api/cafeteria/cortes/consumos",
    API_URL_CAJAS : appConfig.API_URL + "/api/cafeteria/cajas",
    API_URL_CORTES_ULTIMO : appConfig.API_URL + "/api/cafeteria/cortes/{cajaID}/ultimo",
    API_URL_CORTES_COUNT : appConfig.API_URL + "/api/cafeteria/cortes/{corteID}/count",
    API_URL_CORTE : appConfig.API_URL + "/api/cafeteria/cortes",
   };

   export default apiConfig;